/**
 * The pages that follow the Dark appearance. Everything else stays light
 * whatever the appearance, because its markup/styles only have a light form.
 *
 * Shared by DefaultLayoutComponent (dark #right-panel backdrop + the
 * `sa-dark-chrome` class on <body>, which modern-master-ui.css keys the
 * modernised pages' dark palette off) and HeaderComponent (dark bar), so the
 * two can never disagree about which pages are dark.
 */

/** Matched as the path itself or any sub-path (e.g. /analytics/fake). */
const DARK_CHROME_PREFIXES = [
  // new dashboard and the reports reached from it
  "/dashboard1",
  "/analytics",
  "/product-intelligence",
  "/generated-qr-report",
  "/inventory-report",
  "/configuration",
  // modernised (.saml) master / transaction / report pages
  "/masters/productconfiguration",
  "/masters/productmaster",
  "/masters/rolemaster",
  "/masters/usermaster",
  "/numberactive/productallocation",
  "/transactions/hologramdamage",
  "/transactions/schemedemapping",
  "/reports/verificationrpt",
  "/reports/mappingrpt",
  "/reports/ratingrpt",
  "/reports/feedbackrpt",
  "/reports/demappingrpt",
  "/reports/damagerpt",
];

export function isDarkChromePath(url: string): boolean {
  const path = String(url || "").split("?")[0].split("#")[0];
  return DARK_CHROME_PREFIXES.some(
    (p) => path === p || path.startsWith(p + "/"),
  );
}
